import React, { useState } from "react";

const MultipleService = (props) => {
  const [openIndex, setOpenIndex] = useState(0); // State to manage the open section index

  const toggleCollapse = (index) => {
    setOpenIndex(openIndex === index ? null : index); // Toggle the collapse state
  };

  return (
    <div>
      <div className="container section-title" data-aos="fade-up">
        <h2 style={{margin:"5px"}}> {props?.serviceHeader}</h2>
        <p>
          <b>{props?.description}</b>
        </p>
      </div>
      <div className="text-center mb-3">
        {props?.sections.map((section, index) => (
          <button
            key={section.id}
            className={`btn mx-2 ${
              openIndex === index ? "btn-success" : "btn-primary"
            }`} // Change button color based on active state
            type="button"
            onClick={() => toggleCollapse(index)}
            aria-expanded={openIndex === index}
            style={{ margin: "3px" }}
            aria-controls={`collapseExample${section.id}`}
          >
           {section.name}
          </button>
        ))}
      </div>

      {props?.sections.map((section, index) => (
        <div key={section.id}>
          <div
            className={`collapse ${openIndex === index ? "show" : ""}`}
            id={`collapseExample${section.id}`}
          >
            <div className="card card-body">
              <div className="row align-items-center">
                <div className="col-md-8">
                  <p>{section?.content}</p>
                </div>
                <div className="col-md-4">
                  <center>
                    <img
                      src={section?.imgSrc}
                      alt={section?.imgAlt}
                      className="img-fluid"
                      style={{ maxWidth: "auto", height: "50%" }}
                    />
                  </center>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MultipleService;
